const abi = [
  {
    inputs: [
      { internalType: "address payable", name: "withdrawAddr", type: "address" },
      { internalType: "contract IAwooToken", name: "awooTokenContract", type: "address" },
      { internalType: "contract IAwooClaimingV2", name: "claimingContract", type: "address" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint16", name: "itemId", type: "uint16" },
      { indexed: false, internalType: "address", name: "purchasedBy", type: "address" },
      { indexed: false, internalType: "uint256", name: "qty", type: "uint256" },
    ],
    name: "ItemPurchased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint16", name: "itemId", type: "uint16" },
      { indexed: false, internalType: "address", name: "usedBy", type: "address" },
      { indexed: false, internalType: "uint256", name: "qty", type: "uint256" },
    ],
    name: "NonMintableItemUsed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "previousOwner", type: "address" },
      { indexed: true, internalType: "address", name: "newOwner", type: "address" },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "uint16", name: "itemId", type: "uint16" },
      { indexed: false, internalType: "address", name: "applicationCollectionAddress", type: "address" },
      { indexed: false, internalType: "uint256", name: "appliedToTokenId", type: "uint256" },
    ],
    name: "UpgradeItemApplied",
    type: "event",
  },
  {
    inputs: [{ internalType: "address", name: "collectionAddress", type: "address" }],
    name: "addCollection",
    outputs: [{ internalType: "uint8", name: "collectionId", type: "uint8" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint16", name: "TotalAvailable", type: "uint16" },
          { internalType: "uint16", name: "PerAddressLimit", type: "uint16" },
          { internalType: "uint16", name: "PerTransactionLimit", type: "uint16" },
          { internalType: "enum AwooStoreV2.PaymentType", name: "PmtType", type: "uint8" },
          { internalType: "bool", name: "Burnable", type: "bool" },
          { internalType: "bool", name: "NonMintable", type: "bool" },
          { internalType: "bool", name: "Active", type: "bool" },
          {
            components: [
              { internalType: "bool", name: "SoftLimit", type: "bool" },
              { internalType: "bool", name: "Active", type: "bool" },
            ],
            internalType: "struct IAwooMintableCollection.TokenDetail",
            name: "TokenDetails",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint8", name: "ApplicableCollectionId", type: "uint8" },
              { internalType: "bool", name: "UpgradeItem", type: "bool" },
              { internalType: "bool", name: "Stackable", type: "bool" },
              { internalType: "uint256", name: "UpgradeBaseAccrualRate", type: "uint256" },
            ],
            internalType: "struct AwooStoreV2.UpgradeDetail",
            name: "UpgradeDetails",
            type: "tuple",
          },
          { internalType: "string", name: "MetadataUri", type: "string" },
          { internalType: "uint256", name: "TokenId", type: "uint256" },
          { internalType: "uint256", name: "EtherPrice", type: "uint256" },
          { internalType: "uint256", name: "AWOOPrice", type: "uint256" },
        ],
        internalType: "struct AwooStoreV2.ItemDetail",
        name: "item",
        type: "tuple",
      },
      { internalType: "uint16", name: "purchasedQty", type: "uint16" },
    ],
    name: "addItem",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint32[]", name: "applicationTokenIds", type: "uint32[]" },
    ],
    name: "applyMintedItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint32[]", name: "applicationTokenIds", type: "uint32[]" },
    ],
    name: "applyOwnedItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint16", name: "itemId", type: "uint16" }],
    name: "availableQty",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "awooClaimingContract",
    outputs: [{ internalType: "contract IAwooClaimingV2", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "awooContract",
    outputs: [{ internalType: "contract IAwooToken", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "awooMintableCollectionContract",
    outputs: [{ internalType: "contract IAwooMintableCollection", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8", name: "collectionId", type: "uint8" },
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" },
    ],
    name: "checkItemTokenApplicationStatus",
    outputs: [
      { internalType: "uint256[]", name: "", type: "uint256[]" },
      { internalType: "uint256[]", name: "", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collectionCount",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    name: "collectionIdAddressMap",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint8", name: "applicableCollectionId", type: "uint8" },
    ],
    name: "getItemApplications",
    outputs: [
      { internalType: "uint256", name: "count", type: "uint256" },
      { internalType: "uint256[]", name: "appliedToTokenIds", type: "uint256[]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "", type: "uint16" },
      { internalType: "uint8", name: "", type: "uint8" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "itemApplications",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "itemCount",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "itemIdDetailMap",
    outputs: [
      { internalType: "uint16", name: "TotalAvailable", type: "uint16" },
      { internalType: "uint16", name: "PerAddressLimit", type: "uint16" },
      { internalType: "uint16", name: "PerTransactionLimit", type: "uint16" },
      { internalType: "enum AwooStoreV2.PaymentType", name: "PmtType", type: "uint8" },
      { internalType: "bool", name: "Burnable", type: "bool" },
      { internalType: "bool", name: "NonMintable", type: "bool" },
      { internalType: "bool", name: "Active", type: "bool" },
      {
        components: [
          { internalType: "bool", name: "SoftLimit", type: "bool" },
          { internalType: "bool", name: "Active", type: "bool" },
        ],
        internalType: "struct IAwooMintableCollection.TokenDetail",
        name: "TokenDetails",
        type: "tuple",
      },
      {
        components: [
          { internalType: "uint8", name: "ApplicableCollectionId", type: "uint8" },
          { internalType: "bool", name: "UpgradeItem", type: "bool" },
          { internalType: "bool", name: "Stackable", type: "bool" },
          { internalType: "uint256", name: "UpgradeBaseAccrualRate", type: "uint256" },
        ],
        internalType: "struct AwooStoreV2.UpgradeDetail",
        name: "UpgradeDetails",
        type: "tuple",
      },
      { internalType: "string", name: "MetadataUri", type: "string" },
      { internalType: "uint256", name: "TokenId", type: "uint256" },
      { internalType: "uint256", name: "EtherPrice", type: "uint256" },
      { internalType: "uint256", name: "AWOOPrice", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
      {
        components: [
          { internalType: "bytes32", name: "Hash", type: "bytes32" },
          { internalType: "bytes", name: "Sig", type: "bytes" },
          { internalType: "string", name: "Nonce", type: "string" },
        ],
        internalType: "struct AwooStoreV2.AwooSpendApproval",
        name: "approval",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "ContractAddress", type: "address" },
          { internalType: "uint32[]", name: "TokenIds", type: "uint32[]" },
        ],
        internalType: "struct ClaimDetails[]",
        name: "requestedClaims",
        type: "tuple[]",
      },
    ],
    name: "mintWithAwoo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
    ],
    name: "mintWithEth",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
      {
        components: [
          { internalType: "bytes32", name: "Hash", type: "bytes32" },
          { internalType: "bytes", name: "Sig", type: "bytes" },
          { internalType: "string", name: "Nonce", type: "string" },
        ],
        internalType: "struct AwooStoreV2.AwooSpendApproval",
        name: "approval",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "ContractAddress", type: "address" },
          { internalType: "uint32[]", name: "TokenIds", type: "uint32[]" },
        ],
        internalType: "struct ClaimDetails[]",
        name: "requestedClaims",
        type: "tuple[]",
      },
    ],
    name: "mintWithEthAndAwoo",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint16", name: "", type: "uint16" },
    ],
    name: "mintedItemCountsByAddress",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint16", name: "", type: "uint16" },
    ],
    name: "ownedItemCountsByOwner",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      {
        components: [
          { internalType: "bytes32", name: "Hash", type: "bytes32" },
          { internalType: "bytes", name: "Sig", type: "bytes" },
          { internalType: "string", name: "Nonce", type: "string" },
        ],
        internalType: "struct AwooStoreV2.AwooSpendApproval",
        name: "approval",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "ContractAddress", type: "address" },
          { internalType: "uint32[]", name: "TokenIds", type: "uint32[]" },
        ],
        internalType: "struct ClaimDetails[]",
        name: "requestedClaims",
        type: "tuple[]",
      },
      { internalType: "uint32[]", name: "applicationTokenIds", type: "uint32[]" },
    ],
    name: "purchaseAndApplyWithAwoo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint32[]", name: "applicationTokenIds", type: "uint32[]" },
    ],
    name: "purchaseAndApplyWithEth",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      {
        components: [
          { internalType: "bytes32", name: "Hash", type: "bytes32" },
          { internalType: "bytes", name: "Sig", type: "bytes" },
          { internalType: "string", name: "Nonce", type: "string" },
        ],
        internalType: "struct AwooStoreV2.AwooSpendApproval",
        name: "approval",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "ContractAddress", type: "address" },
          { internalType: "uint32[]", name: "TokenIds", type: "uint32[]" },
        ],
        internalType: "struct ClaimDetails[]",
        name: "requestedClaims",
        type: "tuple[]",
      },
      { internalType: "uint32[]", name: "applicationTokenIds", type: "uint32[]" },
    ],
    name: "purchaseAndApplyWithEthAndAwoo",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
      {
        components: [
          { internalType: "bytes32", name: "Hash", type: "bytes32" },
          { internalType: "bytes", name: "Sig", type: "bytes" },
          { internalType: "string", name: "Nonce", type: "string" },
        ],
        internalType: "struct AwooStoreV2.AwooSpendApproval",
        name: "approval",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "ContractAddress", type: "address" },
          { internalType: "uint32[]", name: "TokenIds", type: "uint32[]" },
        ],
        internalType: "struct ClaimDetails[]",
        name: "requestedClaims",
        type: "tuple[]",
      },
    ],
    name: "purchaseWithAwoo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
    ],
    name: "purchaseWithEth",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
      {
        components: [
          { internalType: "bytes32", name: "Hash", type: "bytes32" },
          { internalType: "bytes", name: "Sig", type: "bytes" },
          { internalType: "string", name: "Nonce", type: "string" },
        ],
        internalType: "struct AwooStoreV2.AwooSpendApproval",
        name: "approval",
        type: "tuple",
      },
      {
        components: [
          { internalType: "address", name: "ContractAddress", type: "address" },
          { internalType: "uint32[]", name: "TokenIds", type: "uint32[]" },
        ],
        internalType: "struct ClaimDetails[]",
        name: "requestedClaims",
        type: "tuple[]",
      },
    ],
    name: "purchaseWithEthAndAwoo",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "purchasedItemCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "collectionId", type: "uint8" }],
    name: "removeCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  { inputs: [], name: "renounceOwnership", outputs: [], stateMutability: "nonpayable", type: "function" },
  {
    inputs: [{ internalType: "contract IERC20", name: "token", type: "address" }],
    name: "rescueArbitraryERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "active", type: "bool" }],
    name: "setActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address[2]", name: "admins", type: "address[2]" }],
    name: "setAdmins",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "contract IAwooClaimingV2", name: "awooClaiming", type: "address" }],
    name: "setAwooClaimingContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "contract IAwooMintableCollection", name: "awooCollectionContract", type: "address" }],
    name: "setAwooCollection",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "contract IAwooToken", name: "awooTokenContract", type: "address" }],
    name: "setAwooTokenContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "bool", name: "isActive", type: "bool" },
    ],
    name: "setItemActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address payable", name: "addr", type: "address" }],
    name: "setWithdrawAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "storeActive",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8", name: "", type: "uint8" },
      { internalType: "uint32", name: "", type: "uint32" },
      { internalType: "uint16", name: "", type: "uint16" },
    ],
    name: "tokenAppliedItemCountsByCollection",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      {
        components: [
          { internalType: "uint16", name: "TotalAvailable", type: "uint16" },
          { internalType: "uint16", name: "PerAddressLimit", type: "uint16" },
          { internalType: "uint16", name: "PerTransactionLimit", type: "uint16" },
          { internalType: "enum AwooStoreV2.PaymentType", name: "PmtType", type: "uint8" },
          { internalType: "bool", name: "Burnable", type: "bool" },
          { internalType: "bool", name: "NonMintable", type: "bool" },
          { internalType: "bool", name: "Active", type: "bool" },
          {
            components: [
              { internalType: "bool", name: "SoftLimit", type: "bool" },
              { internalType: "bool", name: "Active", type: "bool" },
            ],
            internalType: "struct IAwooMintableCollection.TokenDetail",
            name: "TokenDetails",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint8", name: "ApplicableCollectionId", type: "uint8" },
              { internalType: "bool", name: "UpgradeItem", type: "bool" },
              { internalType: "bool", name: "Stackable", type: "bool" },
              { internalType: "uint256", name: "UpgradeBaseAccrualRate", type: "uint256" },
            ],
            internalType: "struct AwooStoreV2.UpgradeDetail",
            name: "UpgradeDetails",
            type: "tuple",
          },
          { internalType: "string", name: "MetadataUri", type: "string" },
          { internalType: "uint256", name: "TokenId", type: "uint256" },
          { internalType: "uint256", name: "EtherPrice", type: "uint256" },
          { internalType: "uint256", name: "AWOOPrice", type: "uint256" },
        ],
        internalType: "struct AwooStoreV2.ItemDetail",
        name: "newItem",
        type: "tuple",
      },
    ],
    name: "updateItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint16", name: "itemId", type: "uint16" },
      { internalType: "uint256", name: "qty", type: "uint256" },
    ],
    name: "useOwnedItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAddress",
    outputs: [{ internalType: "address payable", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
];

const contractAddress = process.env.REACT_APP_OLD_STORE_CONTRACT_ADDRESS;

export { abi, contractAddress };
